import { Badge, Group, Paper, Stack, Text } from "@mantine/core"
import type { IProps } from "./interfaces"

/**
 * Live insights paper — topics, current discussion, key points. Only renders
 * when the snapshot has at least one topic; otherwise the smart wrapper would
 * hide us via a falsy gate. Pure presentation.
 */
export const ProgressiveSummaryPanel = ({ progressiveSummary }: IProps): React.JSX.Element | null => {
  if (!progressiveSummary || progressiveSummary.topics.length === 0) return null

  return (
    <Paper withBorder p="xs" mt="sm" bg="var(--mantine-color-dark-7)">
      <Text size="xs" fw={600} c="dimmed" mb={4}>
        Live Insights
      </Text>
      <Group gap={4} mb={4}>
        {progressiveSummary.topics.map((t: string) => (
          <Badge key={t} size="xs" variant="outline">
            {t}
          </Badge>
        ))}
      </Group>
      {progressiveSummary.currentDiscussion && (
        <Text size="xs" c="dimmed">
          {progressiveSummary.currentDiscussion}
        </Text>
      )}
      {progressiveSummary.keyPoints.length > 0 && (
        <Stack gap={2} mt={4}>
          {progressiveSummary.keyPoints.map((p: string) => (
            <Text key={p} size="xs">
              - {p}
            </Text>
          ))}
        </Stack>
      )}
    </Paper>
  )
}
